import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Chip,
  IconButton,
  Stack,
} from '@mui/material';
import MedicationIcon from '@mui/icons-material/Medication';
import AiCardBase from './AiCardBase';

const PrescriptionsAiCard = ({ card, onConfirm, isConfirmed, isConfirming }) => {
  const { cardType, label, data = {} } = card;

  const rawMeds = Array.isArray(data)
    ? data
    : Array.isArray(data.medicines)
    ? data.medicines
    : Array.isArray(data.prescriptions)
    ? data.prescriptions
    : data.medicineName
    ? [data]
    : [];

  const [medicines, setMedicines] = useState(rawMeds);

  useEffect(() => {
    const list = Array.isArray(data)
      ? data
      : Array.isArray(data.medicines)
      ? data.medicines
      : Array.isArray(data.prescriptions)
      ? data.prescriptions
      : data.medicineName
      ? [data]
      : [];
    setMedicines(list);
  }, [data]);

  const handleFieldChange = (index, field, value) => {
    setMedicines((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleConfirm = () => {
    const payload = Array.isArray(data)
      ? medicines
      : { ...data, medicines };
    onConfirm(cardType, payload);
  };

  return (
    <AiCardBase
      cardType={cardType}
      label={label || 'Prescribed Medications'}
      isConfirmed={isConfirmed}
      isConfirming={isConfirming}
      onConfirm={handleConfirm}
      isUpdatedByAi={card.isUpdatedByAi}
    >
      <Box sx={{ py: 1 }}>
        {medicines.length > 0 ? (
          <TableContainer component={Paper} variant="outlined" sx={{ borderRadius: 2, mb: 1 }}>
            <Table size="small">
              <TableHead sx={{ bgcolor: '#F8FAFC' }}>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>Medicine</TableCell>
                  <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>Dosage</TableCell>
                  <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>Frequency</TableCell>
                  <TableCell sx={{ fontWeight: 600, fontSize: 12 }}>Duration</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {medicines.map((med, idx) => {
                  const name = med.medicineName || med.name || 'Prescription Item';
                  return (
                    <TableRow key={idx}>
                      <TableCell sx={{ py: 1 }}>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <MedicationIcon sx={{ color: '#8A4BFF', fontSize: 18 }} />
                          <Typography variant="body2" sx={{ fontWeight: 600 }}>
                            {name}
                          </Typography>
                        </Stack>
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <TextField
                          size="small"
                          disabled={isConfirmed}
                          value={med.dosage || ''}
                          onChange={(e) => handleFieldChange(idx, 'dosage', e.target.value)}
                          placeholder="e.g. 500mg"
                          sx={{ '& input': { fontSize: 12, py: 0.5 } }}
                        />
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <TextField
                          size="small"
                          disabled={isConfirmed}
                          value={med.frequency || ''}
                          onChange={(e) => handleFieldChange(idx, 'frequency', e.target.value)}
                          placeholder="e.g. 1-0-1"
                          sx={{ '& input': { fontSize: 12, py: 0.5 } }}
                        />
                      </TableCell>
                      <TableCell sx={{ py: 1 }}>
                        <TextField
                          size="small"
                          disabled={isConfirmed}
                          value={med.duration || ''}
                          onChange={(e) => handleFieldChange(idx, 'duration', e.target.value)}
                          placeholder="e.g. 14 days"
                          sx={{ '& input': { fontSize: 12, py: 0.5 } }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="body2" sx={{ color: '#94A3B8', fontStyle: 'italic', p: 1 }}>
            No specific medications extracted.
          </Typography>
        )}
      </Box>
    </AiCardBase>
  );
};

export default PrescriptionsAiCard;
